
//Copyright © Northstar Travel Media, LLC. All Rights Reserved - code may not be reused in whole or in part without written consent- removal of this section consitutes a copyright violation
var map = null; var pins = new Array(); var bSetPts = true; var baseZoom = 1; var basepin = null; var baseTyp = null; var bOnDemand = false; var sf; var wr = 0; var lay1; var laybase;
var bSRAPT = null; var bSRHOT = null; var bSRSNDO = null; var bSRDIN = null; var bMapLoaded = false; var markers = [];
var initMarkers = null;

function showRel(bState, relType) {
    var ly; eval('ly=bSR' + relType);
    if (bState) {
        if (ly) {
            for (var i = 0; i < ly.length; i++) {
                ly[i].setMap(map);
            }
        } else {
            var req = new Object;
            req.Type = relType
            req.Latitude = baseLat
            req.Longitude = baseLong
            var DTO = { 'Req': req};
            DynaProxy.invoke("GetNearbyPoints", DTO, function(data) {parseNB(data, relType) }, AjaxFailed)
        }
    } else {
        for (var i = 0; i < ly.length; i++) {
            ly[i].setMap(null);
        }
        
    }
}

function _pinFromDet(Placekey, typ, lt, ln, det, det2) {
    this.Placekey = Placekey;
    this.locs = new google.maps.LatLng(lt, ln);
    this.base = Placekey == baseKey;
    this.typ = typ;
    this.html = det;
    this.near = false;
    this.addr = det2
};
function _pinFromLoc(loc) {

    this.Placekey = loc.PlaceKey;
    this.locs = new google.maps.LatLng(loc.Latitude, loc.Longitude);
    this.base = loc.PlaceKey == baseKey;
    this.typ = loc.Type;
    this.near = false;
    this.loc = loc
}
    
function pushpinclickdrill(loc) {

    var vport = loc.ClusteredViewPort
    if (vport != undefined && vport != "") {

        var pts = port.split(",")
        mypts = new Array();
        mypts.push(new google.maps.LatLng(pts[0], pts[1]))
        mypts.push(new google.maps.LatLng(pts[2], pts[3]))
        var bounds = new google.maps.LatLngBounds();
        $(mypts).each(function (idx, location) { bounds.extend(location); });
        map.fitBounds(bounds);
        mapmoveEnd()
    } else {
        
        map.setCenter(new google.maps.LatLng(loc.Latitude, loc.Longitude));
        map.setZoom(map.getZoom() + 2);
        //mapmoveEnd();
    }
 }
function hidepushpindetail() {
    $(".si-close-button").trigger("click")
}

function mapmoveEnd() {
    if (!bInitload && bCanRefresh) { bUseBounds = true; resetMap(); return false; }
}

function mapzoomEnd() {
    hidepushpindetail();
    if (!bInitload && bCanRefresh) {  bUseBounds = true; resetMap(); return false; }
}

function mAddMapPin(pin, find, addpin, base, idx) {
    
}

function createCirclePushpin( radius, fillColor, strokeColor, strokeWidth, opacity) {
    strokeWidth = strokeWidth || 0;
    var svg = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: fillColor,
        fillOpacity: opacity,
        scale: radius,
        strokeColor: strokeColor,
        strokeWeight: strokeWidth
    };

      return svg
}

function AddMapPin(pin,idx) {if(pin){ return mAddMapPin(pin,false,false,false,idx) }  }  
function AddMapPinLayer(pin,b) {if(pin){  return mAddMapPin(pin,false,b,false,-1) }  } 
function MapDispose() { pins = null; if (map != null) { map.dispose(); map = null; } }

function setView(pts) {
    if (bIsHistory) { return }; if (bSetPts && pts.length > 0) {
        var bounds = new google.maps.LatLngBounds();
        $(pts).each(function (idx, location) { bounds.extend(location); });
        map.fitBounds(bounds);
        bSetPts = false;
    }
}
function GetBounds() {
    
    var points = new Array();
    if (map ==undefined || map == null ) { return "";}
    var view = map.getBounds();

    if (view == undefined || view==null) { return ""; }
    var sw = view.getSouthWest(); var ne = view.getNorthEast()

    if (sw == undefined || sw == null) { return ""; }
    if (ne == undefined || ne == null) { return ""; }
    points.push(new google.maps.LatLng(ne.lat(), sw.lng()));
    points.push(new google.maps.LatLng(sw.lat(), ne.lng()));
    return createEncodings(points);
}

function delmapLayer() {
    return;
    if (lay1) {
        map.layers.remove(lay1); lay1 = null;
    }
}
function maplayer(del) {
    return;
    if (del) { delmapLayer() };
    if (!lay1) { lay1 = new Microsoft.Maps.Layer(); map.layers.insert(lay1); }
    return lay1
}
function baselayer() {
    return;
    if (!laybase) { laybase = new Microsoft.Maps.Layer(); map.layers.insert(laybase); } return laybase;
}
function mShowPins() {
    var shapes = new Array();
    for (var i = 0; i < pins.length; i++) {
        var y = AddMapPin(pins[i], i); if (y) { shapes.push(y); }
    }
}

function fMPop(h) {	if (h == "") { return null; } h = "<div class='map-pop'>" + h + "</div>";    return h}




function initjqpins() {
    $(".cluster-zoom").click(function () {
        hidepushpindetail(); pushpinclickdrill($(this).attr("data-clustered-pts")); return false;
    });

}
var nNavoffset = 60//nav height plus padding


$(document).ready(function () {
    Northstar.maps.loadMapAPI(mapLoaded);
   
    $(".show-rel input").on("click",function () {
        showRel($(this).prop("checked"), $(this).val())
    });

});

function mGetMap() {
    if (bIsHistory) {
        mGetPinData();
        bSetPts = false;
    } else {
        initpins();
        if ($("#map-init-pins").length>0){
            var sJson = $("#map-init-pins").html();
            console.log(sJson)
            if (sJson && sJson != "") {Northstar.maps.addMarkers(sJson, true);}
        }

    }
    saveState(true);
    
}

function mapLoaded(thismap) {
    map = thismap;
    //map.addListener('dragend', function () { mapmoveEnd() });
    //map.addListener('zoom_changed', function () { mapzoomEnd() });    
    loadmap(); //sets base center and zoom
    bLoading = false; bInitload = true;
    window.setTimeout(mGetMap, 500);
}


// Encode a signed number in the encode format.
function encodeSignedNumber(num) {
    var sgn_num = num << 1;
    if (num < 0) { sgn_num = ~(sgn_num); }
    return (encodeNumber(sgn_num));
}

// Encode an unsigned number in the encode format.
function encodeNumber(num) {
    var encodeString = "";
    while (num >= 0x20) {
        encodeString += (String.fromCharCode((0x20 | (num & 0x1f)) + 63));
        num >>= 5;
    }
    encodeString += (String.fromCharCode(num + 63));
    return encodeString;
}

// Create the encoded bounds.
function createEncodings(points) {
    var i = 0;
    var plat = 0;
    var plng = 0;
    var encoded_points = "";

    for (i = 0; i < points.length; ++i) {
        var point = points[i];
        var lat = point.lat();
        var lng = point.lng();
        var late5 = Math.floor(lat * 1e5);
        var lnge5 = Math.floor(lng * 1e5);
        dlat = late5 - plat;
        dlng = lnge5 - plng;
        plat = late5;
        plng = lnge5;
        encoded_points += encodeSignedNumber(dlat) + encodeSignedNumber(dlng);
    }
    return encoded_points;
}
